// Global state to track which component is active
let activeComponent = null;

document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  // Mobile menu functionality
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const mobileMenuDropdown = document.getElementById("mobile-menu-dropdown");

  // Mobile search functionality
  const searchBtn = document.getElementById("search-btn");
  const searchForm = document.getElementById("header__search");
  const searchInput = searchForm?.querySelector(".header__search-input");
  const searchClose = searchForm?.querySelector(".search-form__close");

  // Cart Drawer
  const cartDrawer = document.getElementById("CartDrawer");

  // Controlling Main overlay
  const mainOverlay = document.querySelector(".main__overlay");

  let isTogglingMenu = false;
  // Open/Close Menu
  const toggleMenu = () => {
    if (isTogglingMenu) return; // 🚫 Prevent double trigger
    if (!mobileMenuBtn || !mobileMenuDropdown) return;

    isTogglingMenu = true;
    const isOpening = !mobileMenuBtn.classList.contains("active");

    mobileMenuBtn.classList.toggle("active");
    mobileMenuDropdown.classList.toggle("active");

    // Force animation replay
    const animatedEl = mobileMenuBtn.querySelector(
      isOpening ? ".svg_wrapper" : ".mobile-menu-burger"
    );
    if (animatedEl) {
      animatedEl.style.animation = "none";
      animatedEl.offsetHeight; // trigger reflow
      animatedEl.style.animation = "pop 0.15s ease";
    }

    const submenu = mobileMenuDropdown.querySelector(
      ".mobile-hidden-menu.show"
    );
    if (submenu) {
      submenu.classList.remove("show");
    }

    if (isOpening) {
      if (typeof lockHeader === "function") {
        lockHeader();
      }

      if (activeComponent === "search") closeSearch();
      if (activeComponent === "cart") closeCartDrawer();

      // Add overlay click handler when opening
      if (mainOverlay) {
        mainOverlay.addEventListener("click", toggleMenu);
        mainOverlay.classList.add("active");
        if (typeof adjustOverlay === "function") {
          adjustOverlay();
        }
      }

      // Set active component
      activeComponent = "menu";
    } else {
      if (typeof window.unlockHeader === "function") {
        window.unlockHeader();
      }
      // Remove overlay click handler when closing
      if (mainOverlay) {
        mainOverlay.removeEventListener("click", toggleMenu);
        mainOverlay.classList.remove("active");
        if (typeof resetOverlay === "function") {
          resetOverlay();
        }
      }

      activeComponent = null;
    }

    document.body.style.overflow = mobileMenuBtn.classList.contains("active")
      ? "hidden"
      : "";
    // 🔒 Unlock after short delay to avoid double trigger
    setTimeout(() => {
      isTogglingMenu = false;
    }, 200);
  };

  // Keep track of overlay click handler
  let overlayClickHandler = null;

  const showSearch = () => {
    if (!searchForm) return;

    if (typeof lockHeader === "function") {
      lockHeader();
    }

    if (activeComponent === "cart") closeCartDrawer();
    if (activeComponent === "menu") toggleMenu();

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Use requestAnimationFrame for smoother animation
    requestAnimationFrame(() => {
      searchForm.classList.add("active");
      if (mainOverlay) {
        mainOverlay.classList.add("active");
        if (typeof adjustOverlay === "function") {
          adjustOverlay();
        }

        // Add overlay click handler only once
        if (!overlayClickHandler) {
          overlayClickHandler = (e) => {
            // Only close if clicking directly on overlay (not children)
            if (e.target === mainOverlay) {
              closeSearch(false);
            }
          };
          mainOverlay.addEventListener("click", overlayClickHandler);
        }
      }
      if (searchInput) {
        searchInput.focus();
      }
      activeComponent = "search";
    });
  };

  const closeSearch = () => {
    if (!searchForm || !searchForm.classList.contains("active")) return;

    if (typeof window.unlockHeader === "function") {
      window.unlockHeader();
    }

    // Reset search UI
    searchForm.style.transition = "none";
    searchForm.classList.remove("active");
    if (mainOverlay) {
      mainOverlay.classList.remove("active");
      if (typeof resetOverlay === "function") {
        resetOverlay();
      }
      // Remove overlay click handler
      if (overlayClickHandler) {
        mainOverlay.removeEventListener("click", overlayClickHandler);
        overlayClickHandler = null;
      }
    }
    if (searchInput) {
      searchInput.value = "";
    }
    document.body.style.overflow = "";
    activeComponent = null;
  };

  // Initialize Menu Drawer event listeners
  if (mobileMenuBtn && mobileMenuDropdown) {
    mobileMenuBtn.addEventListener("click", toggleMenu);
  }

  // Initialize Search Drawer event listeners
  if (searchBtn && searchForm) {
    searchBtn.addEventListener("click", showSearch);
    searchClose.addEventListener("click", closeSearch);
  }

  //Open Cart Drawer
  const openCartDrawer = () => {
    if (!cartDrawer || cartDrawer.classList.contains("open")) return;

    if (activeComponent === "search") closeSearch();
    if (activeComponent === "menu") toggleMenu();

    cartDrawer.classList.add("open");
    if (mainOverlay) {
      mainOverlay.classList.add("active");

      // Add overlay click handler only once
      if (!overlayClickHandler) {
        overlayClickHandler = (e) => {
          if (e.target === mainOverlay) {
            closeCartDrawer();
          }
        };
        mainOverlay.addEventListener("click", overlayClickHandler);
      }
    }

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    if (typeof lockHeader === "function") {
      lockHeader();
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    if (!cartDrawer || !cartDrawer.classList.contains("open")) return;

    cartDrawer.classList.remove("open");
    if (mainOverlay) {
      mainOverlay.classList.remove("active");
      // Remove overlay click handler
      if (overlayClickHandler) {
        mainOverlay.removeEventListener("click", overlayClickHandler);
        overlayClickHandler = null;
      }
    }
    document.body.style.overflow = "";
    activeComponent = null;

    if (typeof window.unlockHeader === "function") {
      window.unlockHeader();
    }
  };

  // Close search when clicking outside (header/announcement)
  document.addEventListener("mousedown", (e) => {
    if (activeComponent !== "search") return;

    const searchElements = [
      document.querySelector(".header__search-container"),
      document.getElementById("search-btn"),
    ];

    const clickedInsideSearch = searchElements.some(
      (el) => el && (el === e.target || el.contains(e.target))
    );

    if (!clickedInsideSearch) {
      closeSearch();
    }
  });

  // Modified escape key handler
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      if (activeComponent === "menu") {
        toggleMenu();
      } else if (activeComponent === "search") {
        closeSearch();
      } else if (activeComponent === "cart") {
        closeCartDrawer();
      } else if (activeComponent === "video-popup") {
        closeVideoPopup();
      } else if (activeComponent === "filter") {
        closeFilterDrawer();
      }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  window.activeComponent = activeComponent;

  window.toggleMenu = toggleMenu;
});

const closeAllPopups = (activeComponent) => {
  if (activeComponent === "localization") {
    closeCartDrawer();
    closeFilterDrawer();
    closeSearch();
    closeVideoPopup();

    const mobileMenuBtn = document.getElementById("mobile-menu-btn");
    if (mobileMenuBtn.classList.contains("active")) toggleMenu();
  }
};
